import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { type TCreditCardFormData, updateForm } from "@/redux/slices/formSlice";
import { EFormIds } from "@/utils/enums";

export const useCreditCardForm = () => {
  const creditCardFormData = useAppSelector(
    (state) => state.form.formData[EFormIds.CreditCard]
  );
  const dispatch = useAppDispatch();
  const updateCreditCardFormData = useCallback(
    (newFormData: Partial<TCreditCardFormData>) => {
      dispatch(
        updateForm({
          formId: EFormIds.CreditCard,
          formData: newFormData,
        })
      );
    },
    [dispatch]
  );

  return {
    creditCardFormValid: creditCardFormData.formValid,
    creditCardFormData,
    updateCreditCardFormData,
  };
};
